import React, { useCallback, useContext, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { measurementsActions } from '../../../../store/slices/measurementsSlice/measurementsSlice';
import { openingCalculations } from '../../helpers/openingCalculations';
import { MeasuremntsContext } from '../../Context/MeasuremntsContext';

export const useOpeningCard = (cardId) => {
    const dispatch = useDispatch();
    const { setOpeningsDelete, showPopup, popupProps, hidePopup } = useContext(MeasuremntsContext);
    const selectOptions = useMemo(
        () => [
            {
                title: i18next.t('useOpeningCard.return.selectOptions.door'),
                value: 'door',
            },
            { title: i18next.t('useOpeningCard.return.selectOptions.window'), value: 'window' },
        ],
        []
    );

    const openingCardList = useSelector((state) => state.measurementsReducer.openingsList.entities);
    const openingCard = openingCardList[cardId];

    const selectedType = selectOptions.find(({ value }) => value === openingCard.type);

    const onCloseCard = useCallback(
        (id) => {
            showPopup({
                needCrossIcon: false,
                text: i18next.t('useOpeningCard.return.onCloseCard.text', {
                    type: selectedType.title,
                }),
                danger: i18next.t('useOpeningCard.return.onCloseCard.delete'),
                cancel: i18next.t('useOpeningCard.return.onCloseCard.cancel'),
                onSubmit: () => {
                    hidePopup();
                    setOpeningsDelete((prev) => [...prev, id]);
                    dispatch(measurementsActions.removeOpening(id));
                },
                onCancel: () => hidePopup(),
            });
        },
        [showPopup, popupProps, hidePopup]
    );

    const onInput = useCallback(
        (name, value) => {
            const { area, slope_perimeter, slope_area, perimeter } = openingCalculations({
                ...openingCard,
                [name]: value,
            });
            const changes = { [name]: value, area, slope_perimeter, slope_area, perimeter };
            dispatch(measurementsActions.changeOpening({ id: cardId, changes }));
        },
        [openingCard]
    );

    const onSelect = useCallback(
        (value) => {
            const changes = { type: value };
            dispatch(measurementsActions.changeOpening({ id: cardId, changes }));
        },
        [openingCard]
    );

    return { onCloseCard, onInput, openingCard, selectOptions, selectedType, onSelect };
};
